import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import CirculoFamilia from "@/pages/app/circulo/CirculoFamilia";
import CirculoDocente from "@/pages/app/circulo/CirculoDocente";
import CirculoAdmin from "@/pages/app/circulo/CirculoAdmin";

/** Route dispatcher: shows the Círculo view matching the user's role. */
export default function CirculoRouter() {
  const { user } = useAuth();
  const nav = useNavigate();
  const role = user?.role;
  const isAdminOrPsi = role === "psicologa" || user?.is_admin;

  useEffect(() => {
    if (user && !isAdminOrPsi && role !== "docente" && role !== "sombra" && role !== "familia") {
      nav("/app");
    }
  }, [user, role, isAdminOrPsi, nav]);

  if (!user) return null;
  if (isAdminOrPsi) return <CirculoAdmin />;
  if (role === "docente" || role === "sombra") return <CirculoDocente />;
  if (role === "familia") return <CirculoFamilia />;
  return null;
}
